import PropTypes from 'prop-types';

function EmptyState({
  icon: Icon,
  title,
  message,
  onRetry,
  onAction,
  retryLabel = 'Try Again',
  actionLabel = 'Create New',
  size = 'default',
  showAction = true,
  className = '',
}) {
  if (size === 'small') {
    return (
      <p
        className={`mt-2 flex items-center justify-center gap-1 text-center text-sm text-[#8b7a6d] ${className}`}
      >
        {Icon ? <Icon className="h-4 w-4" aria-hidden="true" /> : null}
        <span>{message}</span>
      </p>
    );
  }

  const paddingClass = size === 'large' ? 'py-20' : 'py-10';

  return (
    <div
      className={`col-span-full flex flex-col items-center justify-center ${paddingClass} px-6 text-center text-[#7d6d61] ${className}`}
    >
      {Icon ? (
        <Icon
          className="mb-4 h-20 w-20 text-[#d4c6b9]"
          strokeWidth={1.5}
          aria-hidden="true"
        />
      ) : null}

      {title ? <h3 className="mb-2 text-xl font-semibold text-[#111111]">{title}</h3> : null}

      {message ? <p className="mb-6 max-w-md text-[#7d6d61]">{message}</p> : null}

      {showAction && (onRetry || onAction) ? (
        <div className="flex gap-3">
          {onRetry ? (
            <button
              onClick={onRetry}
              className="rounded-lg bg-[#5c3821] px-4 py-2 text-white shadow-sm transition hover:bg-[#4b2e1c] active:scale-95"
              type="button"
              aria-label={retryLabel}
            >
              {retryLabel}
            </button>
          ) : null}

          {onAction ? (
            <button
              onClick={onAction}
              className="rounded-lg bg-[#7a4b2a] px-4 py-2 text-white shadow-sm transition hover:bg-[#6b4124] active:scale-95"
              type="button"
              aria-label={actionLabel}
            >
              {actionLabel}
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

EmptyState.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.string,
  message: PropTypes.string,
  onRetry: PropTypes.func,
  onAction: PropTypes.func,
  retryLabel: PropTypes.string,
  actionLabel: PropTypes.string,
  size: PropTypes.oneOf(['small', 'default', 'large']),
  showAction: PropTypes.bool,
  className: PropTypes.string,
};

EmptyState.defaultProps = {
  icon: null,
  title: null,
  message: 'No data available',
  onRetry: null,
  onAction: null,
  retryLabel: 'Try Again',
  actionLabel: 'Create New',
  size: 'default',
  showAction: true,
  className: '',
};

export default EmptyState;
